import * as types from "./mutation_types";

export default {
    [types.SET_FUNCTIONS]: (state, { functions }) =>
        (state.functions = functions)
};
